/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "dream-home-e468610f--sprite",
  "use": "dream-home-e468610f--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"dream-home-e468610f--sprite\"><g transform=\"translate(36 36) rotate(180)\"><g transform=\"translate(36 36) rotate(180)\" opacity=\"0\"><g transform=\"translate(0)\" fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0.5\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g></g></g><g transform=\"translate(4.32 7.199)\"><g transform=\"translate(0 0)\"><path d=\"M10.3.432a1.565,1.565,0,0,0-2.16,0L.576,7.344A1.936,1.936,0,0,0,0,8.64v9.144a3.14,3.14,0,0,0,3.24,3.024H5.688a5.428,5.428,0,0,1-1.44-3.672A5.337,5.337,0,0,1,5.9,13.248a5.736,5.736,0,0,1,3.96-1.584h.288A7.553,7.553,0,0,1,16.56,6.48ZM5.544,11.448a.817.817,0,0,1-.792.864H2.88a.832.832,0,0,1-.864-.864V9.72a.875.875,0,0,1,.864-.864h1.8a.875.875,0,0,1,.864.864Z\" transform=\"translate(0 0)\" fill=\"currentColor\" /></g><g transform=\"translate(5.688 7.776)\"><path d=\"M29.644,21.312a3,3,0,0,1-3.1,2.952H12.076a3.7,3.7,0,0,1-1.8-.432A3.959,3.959,0,0,1,7.9,20.16a4.036,4.036,0,0,1,1.224-2.88,4.2,4.2,0,0,1,2.952-1.224h1.44l.144-.576a6.184,6.184,0,0,1,6.048-4.68h.432a6.042,6.042,0,0,1,5.688,5.9l.072,1.44h.72a3.35,3.35,0,0,1,2.232.864A4.047,4.047,0,0,1,29.644,21.312Z\" transform=\"translate(-7.9 -10.8)\" fill=\"currentColor\" /></g></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
